/* eslint-disable no-undef */

// This is a hack suggested by Dan Ambramov to fix a crash caused by
// Google Chrome's auto-translate feature.
// https://github.com/facebook/react/issues/11538#issuecomment-417504600
// There is an issue logged for chrome here:
// https://bugs.chromium.org/p/chromium/issues/detail?id=872770
//
// Until that is fixed, this hack will prevent the crash.
// The crash will most likely not affect real co-workers, but autotranslate is used by many global users.
export function fixAutotranslateCrash() {
  if (typeof Node === "function" && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
      if (child.parentNode !== this) {
        if (console) {
          // eslint-disable-next-line no-console
          console.error(
            "Cannot remove a child from a different parent",
            child,
            this
          );
        }
        return child;
      }
      return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
      if (referenceNode && referenceNode.parentNode !== this) {
        if (console) {
          // eslint-disable-next-line no-console
          console.error(
            "Cannot insert before a reference node from a different parent",
            referenceNode,
            this
          );
        }
        return newNode;
      }
      return originalInsertBefore.apply(this, arguments);
    };
  }
}
